import React from 'react'
import SwiperCore, { A11y } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import { breakPoints } from '@app/ui/theme'

import { Title, ArticlesList, ArticlesListDesktop, ArticlesListMobile, StyledContainer } from './styles'
import { Article, ArticleProps } from './Article'

interface ArticlesProps {
  title?: string
  articles?: ArticleProps[]
  currentArticleId?: string
}

SwiperCore.use([A11y])

export const Articles = ({ title, articles, currentArticleId }: ArticlesProps) => {
  if (!articles?.length) {
    return null
  }

  return (
    <StyledContainer size="small">
      <>{title && <Title>{title}</Title>}</>
      <ArticlesListDesktop>
        {articles && (
          <ArticlesList>
            {articles.map(article => {
              if (article.id === currentArticleId) {
                return null
              } else {
                return (
                  <Article
                    key={article.id}
                    articleUrl={`/studio/${article.articleUrl}`}
                    title={article.title}
                    image={article.image}
                    category={article.category}
                  />
                )
              }
            })}
          </ArticlesList>
        )}
      </ArticlesListDesktop>
      <ArticlesListMobile>
        <Swiper
          slidesPerView="auto"
          breakpoints={{
            0: {
              spaceBetween: 16
            },
            [breakPoints.mobileL]: {
              spaceBetween: 30
            }
          }}>
          {articles.map(article => {
            if (article.id === currentArticleId) {
              return null
            } else {
              return (
                <SwiperSlide key={article.id}>
                  <Article
                    isSlider
                    articleUrl={`/studio/${article.articleUrl}`}
                    title={article.title}
                    image={article.image}
                    category={article.category}
                  />
                </SwiperSlide>
              )
            }
          })}
        </Swiper>
      </ArticlesListMobile>
    </StyledContainer>
  )
}
